import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import productActions from "../../../store/actions/products/product.actions";
import AlertService from "../../../services/alerts/alert.service";
import TableElementComponent from "../../elements/TableElementComponent";
import SelectInputElementComponent from "../../elements/inputElements/SelectInputElementComponent";

const UpdateProductLinkedItemsDialogComponent = () => {
  const [searchParams] = useSearchParams();
  const productId = searchParams.get("id");

  const dispatch = useDispatch();
  const [linkedItems, setLinkedItems] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState("");

  useEffect(() => {
    loadProduct();
    loadAllProducts();
  }, [productId]);

  const loadProduct = async () => {
    try {
      const response = await dispatch(productActions.getProductById(productId));
      setLinkedItems(response.payload?.attachedProducts || []);
    } catch {
      AlertService.error("שגיאה", "לא ניתן לטעון פרטי מוצר.");
    }
  };

  const loadAllProducts = async () => {
    try {
      const response = await dispatch(productActions.getProducts({ getAll: true }));
      const filtered = response.payload?.items?.filter((p) => p.id !== productId);
      setAllProducts(filtered);
    } catch {
      AlertService.error("שגיאה", "לא ניתן לטעון את רשימת המוצרים.");
    }
  };

  const handleAttach = async () => {
    if (!selectedProductId) return;
    try {
      await dispatch(productActions.attachProduct(productId, selectedProductId));
      AlertService.success("נקשר בהצלחה", "המוצר נקשר בהצלחה.");
      loadProduct();
      setSelectedProductId("");
    } catch {
      AlertService.error("שגיאה", "לא ניתן לקשר את המוצר.");
    }
  };

  const handleUnattach = async (attachedId) => {
    const isConfirmed = await AlertService.confirm("הסרה", "האם להסיר את הקישור למוצר?", "כן", "לא");
    if (!isConfirmed) return;

    try {
      await dispatch(productActions.unattachProduct(productId, attachedId));
      AlertService.success("הוסר בהצלחה", "הקישור הוסר בהצלחה.");
      loadProduct();
    } catch {
      AlertService.error("שגיאה", "לא ניתן להסיר את הקישור.");
    }
  };

  const availableOptions = allProducts.filter((p) => !linkedItems.some((linked) => linked.id === p.id)).map((p) => ({ label: p.productName, value: p.id }));

  const columns = [
    {
      label: "תמונה",
      field: "images",
      render: (images) => {
        const url = images?.[0]?.url || "https://via.placeholder.com/50";
        return <img src={url} alt="מוצר" width={50} height={50} style={{ objectFit: "cover" }} />;
      },
    },
    { label: "שם מוצר", field: "productName" },
    { label: "מחיר", field: "price" },
    // { label: "תיאור", field: "description" },
  ];

  const actions = [
    {
      label: "הסר קישור",
      icon: "fa-solid fa-unlink",
      className: "redButton",
      onClick: (item) => handleUnattach(item.id),
    },
  ];

  return (
    <div className="updateProductLinkedDialog">
      <h2>קישורים למוצרים</h2>

      <div className="attachProductWrapper">
        <SelectInputElementComponent
          props={{
            label: "בחר מוצר לקישור",
            name: "linkedProduct",
            options: availableOptions,
            value: selectedProductId,
            onChange: (e) => setSelectedProductId(e.target.value),
            searchable: true,
          }}
        />
        <button className="primaryButton" onClick={handleAttach} disabled={!selectedProductId}>
          קשר מוצר
        </button>
      </div>

      {linkedItems?.length > 0 && <TableElementComponent columns={columns} data={linkedItems} actions={actions} />}
    </div>
  );
};

export default UpdateProductLinkedItemsDialogComponent;
